import { render, staticRenderFns } from "./Formulas.vue?vue&type=template&id=123016b1&scoped=true&"
import script from "./Formulas.vue?vue&type=script&lang=js&"
export * from "./Formulas.vue?vue&type=script&lang=js&"
import style0 from "./Formulas.vue?vue&type=style&index=0&id=123016b1&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "123016b1",
  null
  
)

export default component.exports